export class ImportedObject {
  constructor(params) {
    if (!params) {
      this.title = undefined;
      this.short_title = undefined;
      this.description = undefined;
      this.image = undefined;
      this.imageList = undefined;
      this.price = undefined;
      this.currency = undefined;
      this.url = undefined;
      this.site = undefined;
      this.commentaire = undefined;
    } else {
      const {
        title = undefined,
        short_title = undefined,
        description = undefined,
        image = undefined,
        imageList = undefined,
        price = undefined,
        currency = undefined,
        url = undefined,
        site = undefined,
        commentaire = undefined,
      } = params;
      this.title = title || short_title || "Sans titre";
      this.shortTitle = short_title;
      this.description = description;
      this.image = image;
      this.imageList = Array.isArray(imageList) ? imageList : undefined;
      this.price = price;
      this.currency = currency || "€";
      this.url = url;
      this.site = site;
      this.commentaire = commentaire;
    }
  }

  getDisplayPrice() {
    return `${this.price.toFixed(2)} ${this.currency}`;
  }

  isValid() {
    return !!this.title && !!this.url;
  }
}

